import Model from '@ember-data/model';
import attr from 'ember-data/attr';

export default class IntegrationsMparticleModel extends Model {
  @attr('string') key!: string;
  @attr('string') secret!: string;
  @attr('array', { defaultValue: () => [] }) events!: string[];
  @attr('boolean', { defaultValue: false }) resolution!: boolean;
  @attr('boolean', { defaultValue: false }) enabled!: boolean;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'integrations/mparticle': IntegrationsMparticleModel;
  }
}
